<template>
    <div>
        <el-card>
            <el-row>
                <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/KPI/Index' }">绩效管理</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/KPI/KPISetting' }">绩效设置</el-breadcrumb-item>
                    <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
                </el-breadcrumb>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
                <el-col :span="4">
                    <el-input size="small" clearable v-model="searchName" placeholder="请输入员工姓名/岗位名称/部门名称"></el-input>
                </el-col>
                <el-col :span="1">
                    <el-button icon="el-icon-search" size="small" @click="SearchByName"></el-button>
                </el-col>
                <el-col :span="19" style="text-align:right;">
                    <el-button size="small" type="warning"  plain @click="copyKPI" >{{btntitle}}</el-button>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
                <el-col :span="24">
                    <el-table border :data="KPIList" style="width: 100%" v-loading="loading" size="small" @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="40"></el-table-column>
                        <el-table-column width="120" prop="ItemType" label="KPI类型">
                            <template slot-scope="scope">
                                {{scope.row.KPIType == 0 ?'职能':(scope.row.KPIType == 1 ?'业绩':(scope.row.KPIType == 2 ?'自定义':(scope.row.KPIType == 3 ?'其他':(scope.row.KPIType == 4 ?'内部管理指标':(scope.row.KPIType == 5 ?'客户指标':(scope.row.KPIType == 6 ?'敬业度':(scope.row.KPIType == 7 ?'重点项目':'团队管理')))))))}}
                            </template>
                        </el-table-column>
                        <el-table-column width="140" prop="KPI" label="KPI名称"></el-table-column>
                        <el-table-column width="120" label="周期类型">
                            <template slot-scope="scope">
                                {{scope.row.PeriodType == 1?'季度':'月度' }}
                            </template>
                        </el-table-column>
                        <el-table-column width="120" prop="Period" label="周期"></el-table-column>
                        <el-table-column width="120" prop="TargetType" label="指标类别"></el-table-column>
                        <el-table-column width="120" label="类别">
                            <template slot-scope="scope">
                                {{scope.row.ItemType == 0?'部门':(scope.row.ItemType == 1?'岗位':'个人') }}
                            </template>
                        </el-table-column>
                        <el-table-column width="120" prop="KeyName" label="名称"></el-table-column>
                        <el-table-column width="140" prop="KPIWeight" label="KPI权重"></el-table-column>
                        <el-table-column width="180" prop="Contents" label="细则考核"></el-table-column>
                        <el-table-column prop="Explain" label="指标说明"></el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<script>
import { PrevKPIitem,AddKPIByPrev  } from "../../until/ZeusApiSDK/Logic/KPILogic";
import { getUrlKey  } from "../../until/ZeusApiSDK/Logic/ImageStr";
import { GetCurrentUserInfo } from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { Decrypt,Encrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic"; 
export default {
     data() {
        return {
            title:'上月KPI列表',
            btntitle:'复制上月KPI',
            periodType:0,//周期 0月度 1季度
            searchName:'',//搜索信息
            KPIList:[],//KPI列表
            loading:true,
            currentRole:{},//当前登录用户角色
            currentUser:{},//当前登录用户
            copyIds:'',//将要复制的ids
        }
     },
     created(){
        //获取地址栏periodType参数值
        this.periodType=getUrlKey('periodType');
        if(this.periodType==0){
            this.title='上月KPI列表';
            this.btntitle='复制上月KPI';
        }
        else{
            this.title='上季KPI列表';
            this.btntitle='复制上季KPI';
        }
        
        //获取当前用户角色
        this.getCurrentRole();
        this.getCurrentUserInfo();

        //获取KPI列表
        this.getKPIList();
     },
     methods:{
        //获取当前用户角色
        getCurrentRole:function(){
            var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
            this.currentRole = JSON.parse(Decrypt(currentUserRole));
        },
        //获取当前用户
        getCurrentUserInfo:function(){
            var userinfo = window.sessionStorage.getItem("userinfo");
            userinfo = JSON.parse(Decrypt(userinfo));
            this.currentUser = userinfo;
        },
        //获取KPI列表
        getKPIList:function(){
            console.log('this.periodType',this.periodType)

            PrevKPIitem(this.periodType,this.currentUser.UserCode,this.searchName).then(res=>{
                this.loading=false;
                this.KPIList=res;
            })
        },
        SearchByName:function(){
            this.getKPIList();
        },
        //复制KPI列表
        copyKPI:function(){
            if(this.copyIds==''||this.copyIds==null){
                this.$message({
                    message: '请选择要复制的KPI',
                    type: 'warning'
                });
                return false;
            }
            
            this.copyIds = this.copyIds.substring(0, this.copyIds.length-1);
            AddKPIByPrev(this.copyIds,this.currentUser.UserCode).then(res=>{
                if(res.Result==1){
                    this.$router.push({ path:'/KPI/KPISetting'  })
                }
            });
        },
        handleSelectionChange:function(items){
            var ids='';
            items.forEach(item => {
                ids+=item.Id+',';
            });
            this.copyIds=ids;
        }
     }
}
</script>